import { render, staticRenderFns } from "./oweSummary.vue?vue&type=template&id=ef67762a&"
import script from "./oweSummary.vue?vue&type=script&lang=js&"
export * from "./oweSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports